import 'purecss';
import 'purecss/build/grids-responsive-min.css';
// import 'lightbox2/dist/css/lightbox.min.css'
// import 'lightbox2/dist/js/lightbox.min.js'

import '@babel/polyfill';
import $ from 'jquery';

import 'slick-carousel';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import '../scss/style.scss';

$(() => {
  $(window).on('load scroll', () => {
    $('.animation').each(function () {
      const target = $(this).offset().top;
      const scroll = $(window).scrollTop();
      const height = $(window).height();
      if (scroll > target - height) {
        $(this).addClass('active');
      }
    });
  });
});

window.addEventListener('load', () => {
  $('.multiple-items').slick({
    centerMode: true,
    centerPadding: '400px',
    slidesToShow: 1,
    arrows: true,
    autoplay: true,
    prevArrow: '<img src="/themes/micg2022/solution/creative-design/images/arrow-l.png" class="slide-arrow prev-arrow">',
    nextArrow: '<img src="/themes/micg2022/solution/creative-design/images/arrow-r.png" class="slide-arrow next-arrow">',
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          centerPadding: '200px',
        },
      },
      {
        breakpoint: 1000,
        settings: {
          centerPadding: '40px',
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: '20px',
        },
      },
    ],
  });

  $('.slide-items').slick({
    centerMode: true,
    centerPadding: '400px',
    slidesToShow: 1,
    dots: true,
    autoplay: true,
    arrows: true,
    prevArrow: '<img src="/themes/micg2022/solution/creative-design/images/arrow-l.png" class="slide-arrow prev-arrow">',
    nextArrow: '<img src="/themes/micg2022/solution/creative-design/images/arrow-r.png" class="slide-arrow next-arrow">',
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          centerPadding: '200px',
        },
      },
      {
        breakpoint: 1200,
        settings: {
          centerPadding: '40px',
        },
      },
      {
        breakpoint: 480,
        settings: {
          centerPadding: '20px',
        },
      },
    ],
  });
});
